import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Approach',
  href: '#approach'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Results',
  href: '#results'
}, {
  label: 'Method',
  href: '#method'
}, {
  label: 'About',
  href: '#about'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-ink-950/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent border-b border-transparent'}`} data-id="element-68" data-mp="31e1t04tyql04">
      <div className="mx-auto flex h-20 max-w-container items-center justify-between px-6 lg:px-8" data-id="element-69" data-mp="3fayj2429byfy">
        <a href="#top" className="flex items-center gap-2.5" data-id="element-70" data-mp="2wl4ecn3je0em">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-gold-500 font-display text-lg font-semibold text-ink-950" data-id="element-71" data-mp="2wihzs3i8akmw">
            M
          </span>
          <span className="font-display text-xl font-semibold tracking-tight text-white" data-id="element-72" data-mp="2mmx1ogga64if">
            MAEDSO
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" data-id="element-73" data-mp="3fb2mt4b8xvis">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-white/70 transition-colors hover:text-white" data-id="element-74" data-mp="3aciywyd3e9ns">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden md:block" data-id="element-75" data-mp="30lwnlgces5aw">
          <a href="https://calendly.com/jmctagency/disco" target="_blank" rel="noreferrer" className="rounded-full bg-gold-500 px-5 py-2.5 text-sm font-semibold text-ink-950 transition-colors hover:bg-gold-400" data-id="element-76" data-mp="1w5zazhdk3r4">
            Book a strategy call
          </a>
        </div>

        <button type="button" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(v => !v)} className="text-white md:hidden" data-id="element-77" data-mp="1wbmjas1acz68">
          {open ? <XIcon className="h-6 w-6" data-id="element-78" data-mp="1ml08db4ikwtv" /> : <MenuIcon className="h-6 w-6" data-id="element-79" data-mp="18nbpg8u0bzrg" />}
        </button>
      </div>

      {open && <div className="border-t border-white/10 bg-ink-950/95 px-6 py-4 md:hidden" data-id="element-80" data-mp="1coow2l4xc6zf">
          <nav className="flex flex-col gap-4" data-id="element-81" data-mp="1cmkljkcis9q6">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="text-base font-medium text-white/80" data-id="element-82" data-mp="yr0bleerr1uw">
                {link.label}
              </a>)}
            <a href="https://calendly.com/jmctagency/disco" target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="mt-2 rounded-full bg-gold-500 px-5 py-3 text-center text-sm font-semibold text-ink-950" data-id="element-83" data-mp="2y0oyucgz8dzf">
              Book a strategy call
            </a>
          </nav>
        </div>}
    </header>;
}